module.exports = __webpack_public_path__ + "img/double-image-hero-mazda.3ccdb367.png";